


// Delegación global: cubre los 12 iniciales y los que se cargan después
document.addEventListener('click', (ev) => {
  const btn = ev.target.closest('.js-wa');
  if (!btn) return;
  ev.preventDefault();

  const title = btn.dataset.title || '';
  const url   = 'https://biologika.co/collections/evento-ecologia-2025?utm_source=congreso-ecologia-2025&utm_medium=catalogo&utm_campaign=evento';
  const img   = btn.dataset.image || '';
  const phone = btn.dataset.phone || '573013474737'; // fallback por si acaso

  // Mensaje + UTM + preview (última URL = imagen)
  const textLines = [
    'Hola Estoy interesado en:',
    `• ${title}`,
    '¿Me ayudas?',
    `Más info: ${url}`,
    // Para forzar preview, deja la imagen al final:
    img ? `Imagen: ${img}` : ''
  ].filter(Boolean);

  const text = textLines.join('\n');
  // Construye URLs robustas
  const q = new URLSearchParams({ phone, text: text });
  const waMobile = `https://api.whatsapp.com/send?${q.toString()}`;   // móvil universal
  const waWeb    = `https://web.whatsapp.com/send?${q.toString()}`;   // escritorio

  const isDesktop = !/Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  window.open(isDesktop ? waWeb : waMobile, '_blank', 'noopener,noreferrer');
}, { passive: false });